import { Button, Callout } from "@octopusdeploy/design-system-components";
interface GitHubWebAppRegistrationCalloutProps {
    onClose: () => void;
}
export function GitHubWebAppRegistrationCallout({ onClose }: GitHubWebAppRegistrationCalloutProps) {
    const handleRefreshPage = () => window.location.reload();
    return (<Callout type="information" title="Complete the configuration" canClose={true} onClose={onClose}>
            <div>
                <p>Refresh to complete the configuration for Octopus Deploy GitHub app</p>
                <Button importance="loud" label="Refresh" onClick={handleRefreshPage}/>
            </div>
        </Callout>);
}
